<div
  class="additional"
  [class.additional--alone]="!reviewer()"
>
  @if (author()) {
  <ng-container
    *ngTemplateOutlet="authorTemplate; context: { person: author().attributes }"
  />
  } @if (reviewer()) {
  <ng-container
    *ngTemplateOutlet="authorTemplate; context: { person: reviewer().attributes }"
  />
  } @if (articleModified()) {
  <div class="additional__modified modified">
    <span class="additional__subtitle">{{ articleModified() | date : 'dd.MM.YYYY' }}</span>
  </div>
  }
</div>

<ng-template
  #authorTemplate
  let-person="person"
>
  <div class="author">
    <img
      alt="author-image"
      class="author__img"
      [src]="person | map : getImageUrl"
    />
    <div class="author__wrapper">
      <a
        rel="nofollow"
        target="_blank"
        class="author__name"
        [href]="person | map : getLink"
      >
        {{ person | map : getName }},
      </a>
      <span class="additional__text">{{ person | map : getProfession }}</span>
    </div>
  </div>
</ng-template>
